import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "app-maker-event-request-answer" as const;

export type AppMakerEventRequestAnswerEventData = {
  eventId: string;
  isAccepted: boolean;
  isCreatedByVisitor: boolean;
};
export type AppMakerEventRequestAnswerEvent = AppEvent<
  typeof eventName,
  AppMakerEventRequestAnswerEventData
>;

export const isAppMakerEventRequestAnswerEvent = (
  event: AnyAppEvent
): event is AppMakerEventRequestAnswerEvent => event.name === eventName;

export { eventName as appMakerEventRequestAnswer };
